import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ErrorPolicyService } from '@mri-platform/angular-error-handling';
import { routeResolveEntities, RoutingEventsService } from '@mri-platform/shared/core';
import { Observable, take } from 'rxjs';
import { DashboardsAvailabilityService } from './dashboards-availability.service';

@Injectable({ providedIn: 'root' })
export class ReportInfoHasAnyResolver implements Resolve<boolean> {
  constructor(
    private readonly router: Router,
    private readonly routingEvents: RoutingEventsService,
    private readonly errorPolicyService: ErrorPolicyService,
    private readonly dashboardsAvailabilityService: DashboardsAvailabilityService
  ) {}

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.routingEvents.isInitialNavigation$.pipe(
      routeResolveEntities(
        () => this.dashboardsAvailabilityService.hasDashboards$.pipe(take(1)),
        this.router,
        this.errorPolicyService
      )
    );
  }
}
